import { render, staticRenderFns } from "./NotificationText.vue?vue&type=template&id=26c36ce6&scoped=true&"
import script from "./NotificationText.vue?vue&type=script&lang=js&"
export * from "./NotificationText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c36ce6",
  null
  
)

export default component.exports